import { ListViewProvider, useListView } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListHeader } from './components/header/ListHeader'
import { KTCard } from '../../../../_metronic/helpers'
import { DongBoTable } from './table/DongBoTable'
import { DongBoEditModal } from './dongbo-edit-modal/DongBoEditModal'

const NhaCungCapList = () => {
  const { itemIdForUpdate } = useListView()
  return (

    <>
      <KTCard>
        <ListHeader />
        <DongBoTable />
      </KTCard>
      {itemIdForUpdate !== "" && <DongBoEditModal />}
    </>
  )
}

const DongBoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <NhaCungCapList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { DongBoListWrapper }
